import Diaporama from './pages/Diaporama';
import Uploads from './pages/Uploads';
import Files from './pages/Files';
import Test from './pages/Test';

export const routes = [Diaporama, Files, Uploads, Test];
